import styled from "styled-components";
import { DashboardTotalCard } from "./DashboardTotalCard";

interface Props {
  dashboardData: {
    totalCustomers: number;
    totalMerchants: number;
    alMahaDrive: number;
  };
}

export const DashboardCard = ({ dashboardData }: Props) => {
  let dashboardTotalData = [
    {
      key: "totalCustomers",
      text: "Total Customer",
      imageSrc: "customer",
    },
    {
      key: "totalMerchants",
      text: "Total Merchant",
      imageSrc: "merchant",
    },
    {
      key: "alMahaDrive",
      text: "Al-Maha Drive Subscription",
      imageSrc: "almaha-drive",
    },
  ];

  dashboardTotalData.forEach((item: any) => {
    let keyVal = "count";
    if (item.key === "totalCustomers") {
      item[keyVal] = dashboardData?.totalCustomers;
    }
    if (item.key === "totalMerchants") {
      item[keyVal] = dashboardData?.totalMerchants;
    }
    if (item.key === "alMahaDrive") {
      item[keyVal] = dashboardData?.alMahaDrive;
    }
  });

  return (
    <LayoutContainer>
      <StyledBox>
        <StyledBoxContainer>
          {dashboardTotalData?.map((data: any, idx: any) => (
            <DashboardTotalCard
              totalText={data.text}
              totalCount={data.count}
              imageSrc={data.imageSrc}
              key={idx}
            />
          ))}
        </StyledBoxContainer>
      </StyledBox>
    </LayoutContainer>
  );
};

const StyledBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2.5rem;
  padding: 1.875rem 2.438rem 2.75rem;
  @media only screen and (max-width: 1460px) {
    gap: 1.25rem;
    padding: 1.875rem 1.875rem 1.25rem 1.25rem;
  }
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    padding: 0;
    gap: 3rem;
  }
`;

const LayoutContainer = styled.div`
  display: flex;
  margin-top: 2rem;
  @media only screen and (max-width: 768px) {
    margin-top: 0;
  }
`;

const StyledBox = styled.div`
  border-radius: 8px;
  background-color: rgba(204, 204, 204, 0.3);
  width: 100%;
  height: 11.5rem;
  @media only screen and (max-width: 768px) {
    height: auto;
    background: transparent;
  }
`;
